module.exports = __webpack_public_path__ + "static/media/weld_inspect_1.641a3685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_inspect_1.jpg
// module id = 1874
// module chunks = 0